import { render, staticRenderFns } from "./KbzEng.vue?vue&type=template&id=b08519da&"
var script = {}
import style0 from "./KbzEng.vue?vue&type=style&index=0&id=b08519da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports